module.exports = __webpack_public_path__ + "img/0Q3A6963_L_Wood_MockedUp.f9601a9f.jpg";